import React from 'react';
import styled from 'styled-components';
import moment from 'moment';

import { useLanguage } from '../../../../Context/LanguageContext';

export default function PartnerGymRefundInfoView(props) {
  const { data } = props;
  const { t } = useLanguage();

  function decidePriceView() {
    if (data.refundCardPrice === 0) return t('partnerGym.history.refundCashOnly', { amount: data.refundCashPrice.toLocaleString('ko-KR') });
    else if (data.refundCashPrice === 0) return t('partnerGym.history.refundCardOnly', { amount: data.refundCardPrice.toLocaleString('ko-KR') });
    else return t('partnerGym.history.refundCardAndCash', { cardAmount: data.refundCardPrice.toLocaleString('ko-KR'), cashAmount: data.refundCashPrice.toLocaleString('ko-KR') });
  }

  return (
    <TopLevelWrapper>
      <ComponentBox>
        <TotalTextWrapper>
          <TextWrapper width={79}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#FFFFFF' cursor='pointer'>{t('partnerGym.history.refundComplete')}</Text>
          </TextWrapper>
          <TextWrapper width={95}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#FFFFFF' cursor='pointer'>{moment(data.refundApprovalDate).format('YYYY.MM.DD')}</Text>
          </TextWrapper>
          <TextWrapper width={217}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#FFFFFF' cursor='pointer'>{decidePriceView()}</Text>
          </TextWrapper>
          <TextWrapper width={385}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#FFFFFF' cursor='pointer'>{data.reason}</Text>
          </TextWrapper>
        </TotalTextWrapper>
      </ComponentBox>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: flex-start;

  width: 100%;
`;

const ComponentBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: -35px;

  width: 88.62%;
  height: 87px;

  border-radius: 0px 0px 12px 12px;
  box-shadow: 0px 1px 30px rgba(0, 0, 0, 0.1);
  background-color: #E35655;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const TotalTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-left: 16px;

  margin-top: 50px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-right: 8px;

  width: ${props => props.width}px;
  height: 20px;

  overflow: hidden;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;
